import React from "react";
import useProfile from "@/features/challenge/hooks/useProfile";
import {
  Avatar,
  Box,
  Callout,
  Flex,
  Heading,
  Spinner,
  Text,
} from "@radix-ui/themes";

type Props = {
  uid: string;
  userName: string;
  score: string;
  rank: number;
  orientation?: "horizontal" | "vertical";
};

const PrecisionGameUIWinnersItem: React.FC<Props> = ({
  uid,
  userName,
  score,
  rank,
  orientation = "horizontal",
}) => {
  const { profile, loading } = useProfile(uid);

  if (loading) {
    return <Spinner />;
  }

  const top3 = [1, 2, 3].includes(rank);
  const isVertical = orientation === "vertical";

  return (
    <>
      <Callout.Root
        variant={top3 ? "soft" : "outline"}
        size="1"
        style={{ display: "flex", width: "100%" }}
      >
        <Box width="100%" minWidth="100%" gridColumn="1 / -1">
          <Flex align="center" justify="start" gap="5" wrap="wrap">
            {/* User */}
            <Flex align="center" gap="2">
              {/* Avatar */}
              <Avatar
                src={profile ? profile.avatar : ""}
                fallback={userName ? userName.slice(0, 1) : "U"}
                radius="full"
                size={isVertical ? "4" : "1"}
              />

              <Box maxWidth="100%">
                {/* Username */}
                {userName && (
                  <Heading
                    as="h3"
                    size={isVertical ? "3" : "2"}
                    my="0"
                    truncate
                  >
                    {userName}
                  </Heading>
                )}
              </Box>
            </Flex>

            {/* Points */}
            <Box ml="auto" pr="3">
              <Text size={isVertical ? "3" : "2"} color="gray">
                {score}
              </Text>
            </Box>
          </Flex>
        </Box>
      </Callout.Root>
    </>
  );
};

export default PrecisionGameUIWinnersItem;
